import DefaultModal from 'components/Modal/DefaultModal';
import React, { useCallback, useState, useEffect } from 'react';
import { Input } from 'reactstrap';
import ReactButton from 'components/Buttons/ReactButton';
import { toast } from 'react-toastify';

const InputModalSelected = ({
  isModalOpen,
  onModalToggle,
  template,
  templateParamRegExp,
  setStoreValuesContact,
  storeValuesContact,
  inputs
}) => {
  const [optionSelects, setOptionSelects] = useState([]);

  useEffect(() => {
    if (template) {
      const matches = template?.description?.match(templateParamRegExp);
      if (matches) {
        const newOptions = matches?.map((match, index) => {
          return optionSelects[index] || 'Texto Livre';
        });
        setOptionSelects(newOptions);
      }
    }
  }, [template, templateParamRegExp]);

  useEffect(() => {
    const timeout = setTimeout(() => {
      setOptionSelects((prevOptions) => prevOptions);
    }, 1000);

    return () => clearTimeout(timeout);
  }, [optionSelects]);

  const handleWrite = (value, index) => {
    const updatedStoreValuesContact = { ...storeValuesContact };
    if (optionSelects[index] === 'Texto Livre') {
      updatedStoreValuesContact[index] = { value, type: 'Text' };
    } else {
      updatedStoreValuesContact[index] = { value, type: 'Client_field' };
    }
    setStoreValuesContact(updatedStoreValuesContact);
  };

  const saveModal = useCallback(() => {
    if (Object.keys(storeValuesContact).length === 0) {
      toast.error('Não há nenhum valor preenchido');
    } else {
      const hasEmptyValue = Object.values(storeValuesContact).some(
        (value) => value === ''
      );
      if (hasEmptyValue) {
        toast.error('Há valor vazio');
      } else {
        onModalToggle(false);
      }
      for (let i = 0; i < Object.keys(storeValuesContact).length; i++) {
        inputs[i].value = storeValuesContact[i].value;
      }
    }
  }, [onModalToggle, storeValuesContact]);

  const closeModal = useCallback(() => {
    onModalToggle(false);
  }, [onModalToggle]);

  return (
    <DefaultModal
      show={isModalOpen}
      onModalToggle={onModalToggle}
      title="Selecione dados do template"
      showCloseButton={false}
      modalContainerClasses="modal-lg"
      closeModal={closeModal}
    >
      {template && (
        <>
          <h2>{template?.description}</h2>

          {template?.description
            ?.match(templateParamRegExp)
            ?.map((match, index) => (
              <div
                key={index}
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'flex-start'
                }}
              >
                <p style={{ fontWeight: 'bold' }}>{`{{${index + 1}}}`}</p>

                <Input
                  type="textarea"
                  placeholder=""
                  value={storeValuesContact[index]?.value || ''}
                  onChange={(e) => {
                    handleWrite(e.target.value, index);
                  }}
                  style={{ marginBottom: '20px', height: '60px' }}
                />
              </div>
            ))}
          <div style={{ marginTop: '20px' }}>
            <ReactButton
              color="primary"
              type="submit"
              style={{ marginRight: '10px' }}
              onClick={saveModal}
            >
              Salvar
            </ReactButton>
            <ReactButton
              btnColor="cancelation"
              type="submit"
              onClick={closeModal}
            >
              Voltar
            </ReactButton>
          </div>
        </>
      )}
    </DefaultModal>
  );
};

export default InputModalSelected;
